import { render, staticRenderFns } from "./VolumesPerProduct.vue?vue&type=template&id=1d60f69e"
import script from "./VolumesPerProduct.vue?vue&type=script&lang=js"
export * from "./VolumesPerProduct.vue?vue&type=script&lang=js"
import style0 from "./VolumesPerProduct.vue?vue&type=style&index=0&id=1d60f69e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports